import React from "react";
import { Bell, Search, Menu } from "lucide-react";

function Topbar({ user, setSidebarOpen }) {
  return (
    <header className="bg-white border-b border-slate-200 px-4 md:px-6 py-4 flex items-center justify-between sticky top-0 z-20">
      <div className="flex items-center gap-3">
        <button
          onClick={() => setSidebarOpen(true)}
          className="md:hidden p-3 rounded-xl border border-slate-200 bg-white"
        >
          <Menu size={20} />
        </button>

        <h2 className="text-xl md:text-2xl font-bold text-slate-900">
          Dashboard
        </h2>
      </div>

      <div className="flex items-center gap-3">
        <div className="hidden md:flex items-center bg-slate-100 rounded-xl px-3 py-2 w-72">
          <Search size={16} className="text-slate-500" />
          <input
            type="text"
            placeholder="Search..."
            className="bg-transparent outline-none px-2 w-full text-sm"
          />
        </div>

        <button className="relative p-2 rounded-xl bg-slate-100 hover:bg-slate-200 transition">
          <Bell size={18} />
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-[10px] text-white flex items-center justify-center">
            3
          </span>
        </button>

        <div className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold uppercase">
          {user?.name ? user.name.charAt(0) : "U"}
        </div>
      </div>
    </header>
  );
}

export default Topbar;